// 書いている指示に、送れる中身があるか。空白と改行だけなら中身はない（BE も前後の空白を除いて空なら断る。runTurnBodySchema）。
// 送れるか、操作がないときに入口へ戻すか、断られた指示を入力欄に戻すかを、同じ判定で決める。
// 判定が食い違うと、空白だけを書いたときに、送れないのに入口へも戻らない状態になるためである
export const hasPromptText = (prompt: string): boolean => prompt.trim() !== ''
